module.exports = __webpack_public_path__ + "static/media/Tower_Silverchest_openingV2_compressed.bca344b8.mp4";